import React, {Component} from 'react';
import {connect} from 'react-redux';

import {
    Button,
    Jumbotron
} from 'reactstrap';

import {displayModal, hideModal, setIsLoading} from '../../../store/actions/display';
import PolyUtil from '../../../util/PolyUtil';
import AddListingForm from '../listings/AddListingForm';
import InviteTenantForm from '../listings/InviteTenantForm';
import AddPropertyForm from './AddPropertyForm';
import WidePropertyCard from '../../../components/properties/WidePropertyCard';
import OwnerPropertyCard from './OwnerPropertyCard';
import Loader from "../../../components/display/Loader";
import ReduxModalWrapper from "../../../components/display/Modals/ReduxModalWrapper";

class OwnerProperties extends Component {
    state = {
        showPropertyModal: false,
        activeProperty: null,
        activeAddress: null
    };

    showAddPropertyModal = () => {
        this.props._displayModal({
            id: "add_property_modal",
            header: "Add Property",
            body: (<AddPropertyForm/>),
        });
    };

    showAddListingModal = (propId) => {
        this.props._displayModal({
            id: "add_listing_modal",
            header: "New Listing",
            body: (<AddListingForm propId={propId}/>)
        });
    };

    showInviteTenantModal = (propId) => {
        this.props._displayModal({
            id: "invite_tenant_modal",
            header: "Invite Tenant(s)",
            body: (<InviteTenantForm propId={propId}/>)
        });
    };

    render() {
        const {properties} = this.props;
        return (
            <Loader spin isLoading={!properties}>
                <Button outline color="primary" className="float-right" onClick={this.showAddPropertyModal}>Add Property</Button>
                <h2 className="mt-4 mb-0">Properties</h2>
                <hr/>
                {
                    properties && properties.length > 0 ? properties.map((prop, i) => {
                        return (
                            <WidePropertyCard
                                key={i}
                                display_address={prop.display_address}
                                city={prop.city}
                                state={prop.state}
                                image={prop.image}
                                identifier={prop.identifier}>
                                <OwnerPropertyCard
                                    propId={prop.id}
                                    toggleAddListingModal={() => this.showAddListingModal(prop.id)}
                                    toggleInviteTenantModal={() => this.showInviteTenantModal(prop.id)}
                                />
                            </WidePropertyCard>
                        );
                    }) : <div>
                        <Jumbotron className="center">
                            <h2>You're ready to go!</h2>
                            <hr/>
                            <p>To add your first property, hit the <strong>Add Property</strong> button at the top right!
                            </p>
                        </Jumbotron>
                    </div>
                }

                <ReduxModalWrapper id="add_property_modal"/>

                <ReduxModalWrapper id="add_listing_modal"/>

                <ReduxModalWrapper id="invite_tenant_modal"/>
            </Loader>
        );
    }
}

const mapStateToProps = (state) => ({
    properties: PolyUtil.validArr(state.owner.properties) ? state.owner.properties.map((property) => {
        return {
            id: property.id,
            display_address: property.address_details && PolyUtil.getPropertyStreetAddress(property),
            city: property.address_details && PolyUtil.getPropertyCity(property),
            state: property.address_details && PolyUtil.getPropertyState(property),
            identifier: property.identifier
        };
    }) : []
});

const mapDispatchToProps = (dispatch) => {
    return {
        setIsLoading(isLoading) {
            return dispatch(setIsLoading(isLoading));
        },
        _displayModal(modalData) {
            return dispatch(displayModal(modalData));
        },
        _hideModal(id) {
            return dispatch(hideModal(id));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(OwnerProperties);



// WEBPACK FOOTER //
// ./src/containers/owner/properties/OwnerProperties.js